import { OrderType } from 'app/enums/order-types';
import { DestinationForm } from './ByDestination/ByDestination.model';

export enum SearchType {
  Destination = 'destination',
  Line = 'line',
}

export interface IReservationBar extends DestinationForm {
  orderType: OrderType;
  searchType: SearchType;
}